import { range } from "lodash";
import React, { useContext, useEffect, useRef } from "react";
import GratefulDB from "../../GratefulDB";
import GratefulDBContext from "../../GratefulDBContext";
import { Constants } from "../shared/Constants";
import "./FilterPopup.scss";

const FilterPopup: React.FC<{
  yearState: [string, React.Dispatch<React.SetStateAction<string>>];
}> = (props): JSX.Element => {
  const chunkConfig = useContext<GratefulDB>(GratefulDBContext).chunkConfig();
  const filter = useRef<HTMLDivElement>(null);
  const dropdown = useRef<HTMLDivElement>(null);
  const popup = useRef<HTMLDivElement>(null);
  const [year, setYear] = props.yearState;
  const placeholder = "Select year...";

  useEffect(() => {
    if (!filter.current || !popup.current || !dropdown.current) {
      return;
    }

    // @ts-ignore
    $(filter.current).popup({
      hoverable: true,
      inline: true,
      position: "bottom right",
      lastResort: true,
      on: "manual",
      // @ts-ignore
      popup: $(popup.current),
      delay: {
        hide: 1500,
      },
    });

    // @ts-ignore
    $(dropdown.current).dropdown({
      clearable: true,
      placeholder: placeholder,
      onChange: setYear,
    });
  }, [setYear]);

  useEffect(() => {
    if (!year) {
      if (dropdown.current) {
        // @ts-ignore
        $(dropdown.current).dropdown("clear");
      }
      return;
    }
    if (dropdown.current) {
      // @ts-ignore
      $(dropdown.current).dropdown("set selected", year);
    }
  }, [year]);

  const showPopup = () => {
    if (filter.current) {
      // @ts-ignore
      $(filter.current).popup("show");
    }
  };

  const filterActive = () => year !== Constants.EmptyString;

  return (
    <div className="FilterPopup" ref={filter}>
      {!filterActive() ? (
        <i className={`ui stream big link icon filter`} onClick={showPopup} />
      ) : (
        <button
          className="ui large teal compact button filter-active"
          onClick={showPopup}
        >
          <i className="stream icon" />
          {year}
        </button>
      )}
      <div className="ui popup" ref={popup}>
        <h2 className="ui header popup-header">
          <i className="stream icon" />
          <div className="content">
            <div className="header">Filters</div>
          </div>
        </h2>
        <div className="ui divider" />
        <div className="ui clearable selection dropdown" ref={dropdown}>
          <input type="hidden" name="year" />
          <i className="dropdown icon"></i>
          <div className="default text">{placeholder}</div>
          <div className="menu">
            {range(chunkConfig.yearStart, chunkConfig.yearEnd + 1).map(
              (year) => (
                <div className="item" key={year}>
                  {year}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPopup;
